import {
    FC,
    useState,
    useEffect,
    useCallback
} from "react";
import {
    loadStripe
} from "@stripe/stripe-js";
import {
    Elements
} from "@stripe/react-stripe-js";
import StripeCheckoutForm from "./StripeCheckoutForm";
import "./stripe-container.css";
import { createStripePaymentIntent } from "../../common/async/AsyncCalls";

type IStripeCheckoutContainer = {
    stripe_signature: string,
    amount: number,
    description: string,
    return_url?: string
}


// Make sure to call loadStripe outside of a component’s render to avoid
// recreating the Stripe object on every render.
// This is your test publishable API key.

const StripeCheckoutContainer: FC < IStripeCheckoutContainer > = ({stripe_signature, amount, description, return_url}) => {
    const returnUrl = return_url ?? `${window.location.origin}/#/payment_result`;
    const stripePromise = loadStripe(stripe_signature);
    const [clientSecret, setClientSecret] = useState("");

    const fetchClientSecret = useCallback(async ()=>{
        const response = await createStripePaymentIntent(amount, description);
        const {clientSecret} = response.data;
        setClientSecret(clientSecret);
    },[]);

    useEffect(() => {
        fetchClientSecret();
    }, []);

    const appearance = {
        theme: 'stripe',
    };

    const options: any = {
        clientSecret,
        appearance,
    };

    return ( <div className="stripe-container"> {
        clientSecret && (<Elements options={ options } stripe={stripePromise}>
            <StripeCheckoutForm returnUrl={returnUrl}/></Elements>)} </div>);
};

export default StripeCheckoutContainer;